import { Component, ElementRef, HostListener, Input } from '@angular/core'
import { ProgressIndicatorService } from '@mmx/shared'

@Component({
  selector: 'mmx-copy-text',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
  standalone: false,
})
export class CopyTextComponent {
  @Input() copyValue: string

  @HostListener('click') onClick() {
    this.copy()
  }

  constructor(
    private el: ElementRef,
    private progressService: ProgressIndicatorService,
  ) {}

  copy() {
    const text =
      this.copyValue || this.el.nativeElement.innerHTML.replace(/\n/g, '\n')
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    selBox.value = text
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand('copy')
    document.body.removeChild(selBox)
    this.progressService.snack('Text copied!')
  }
}
